import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { CoverageCheckPage } from './CoverageCheckPage';
import { DonePage } from './DonePage';
import { EnrollmentListPage } from './EnrollmentListPage';
import { PaymentPage } from './PaymentPage';
import { Step1Page } from './Step1Page';
import { Step2Page } from './Step2Page';
import { Step3Page } from './Step3Page';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** "New enrollments": every step of the wizard. */
const WIZARD = 'PC1142';

/** Prepaid/postpaid orders (PC109) routes, mounted under the app shell. */
export const enrollmentsRoutes: RouteObject[] = [
  { path: 'enrollments/new', element: guard(WIZARD, <Step1Page />) },
  { path: 'enrollments/coverage-check', element: guard('PC816', <CoverageCheckPage />) },
  { path: 'enrollments/:id/step/2', element: guard(WIZARD, <Step2Page />) },
  { path: 'enrollments/:id/step/3', element: guard(WIZARD, <Step3Page />) },
  { path: 'enrollments/:id/step/4', element: guard(WIZARD, <PaymentPage />) },
  { path: 'enrollments/:id/done', element: guard(WIZARD, <DonePage />) },
  // `key` gives each list its own filters and page, although they share one component.
  { path: 'enrollments', element: guard('PC1170', <EnrollmentListPage key="all" mode="all" />) },
  {
    path: 'enrollments/completed',
    element: guard('PC1171', <EnrollmentListPage key="completed" mode="completed" />),
  },
  {
    path: 'enrollments/incomplete',
    element: guard('PC1172', <EnrollmentListPage key="incomplete" mode="incomplete" />),
  },
];
